import { FC } from 'react';

import { Carousel } from '@/core/tamagoshi/Carousel/Carousel';
import { Direction } from '@/core/tamagoshi/Carousel/components/Control/Control';
import { H3 } from '@/core/tamagoshiv2/components/Typography/Typography';
import { Gtm } from '@/core/tracking/utils/Gtm';
import { PlaylistGraphQLSkeleton } from '@/domains/productDiscovery/Recommendation/components/PlaylistGraphQL/components/PlaylistGraphQLSkeleton/PlaylistGraphQLSkeleton';
import { usePlaylistTracking } from '@/domains/productDiscovery/Recommendation/components/PlaylistGraphQL/usePlaylistTracking';
import { type ProductCardFragment } from '@/domains/productDiscovery/Recommendation/services/graphql/generated/productCard.fragment.generated';
import { getScrollByFromWidth } from '@/domains/retention/Homepage/b2c/utils/getScrollByFromWidth';

import { ProductCardGraphQL } from './ProductCard';

import styles from './playlistGraphQL.module.scss';

interface Props {
  engineName: string;
  isFetching: boolean;
  products: ProductCardFragment[];
  title: string;
}

export const PlaylistGraphQL: FC<Props> = ({
  engineName,
  isFetching,
  products,
  title,
}) => {
  const { onDisplay, onClick } = usePlaylistTracking(engineName);

  const onArrowClick = (direction: Direction) => {
    Gtm.push({
      amp_event_name: 'Click on navigate playlist',
      e_action: 'click on navigate playlist',
      e_category: 'navigation',
      e_label: `playlist-${engineName}`,
      event: 'interaction_click on navigate playlist',
      event_trigger: `${direction}`,
      playlist_name: `playlist-${engineName}`,
    });
  };

  if (isFetching)
    return (
      <PlaylistGraphQLSkeleton
        className={styles.carrousel}
        cardsNumber={8}
        title={<H3>{title}</H3>}
      />
    );

  return (
    <Carousel
      title={<H3>{title}</H3>}
      trackArrowClick={onArrowClick}
      className={styles.carrousel}
      sliderClassName={styles.slider}
      sliderDirectionOptions={{
        scrollBy: getScrollByFromWidth({ itemWidth: 226, maxScrollBy: 6 }),
      }}
    >
      {products.map((product, index) => (
        <ProductCardGraphQL
          onDisplay={onDisplay}
          onClick={onClick}
          key={product.productId}
          product={product}
          index={index}
        />
      ))}
    </Carousel>
  );
};

PlaylistGraphQL.displayName = 'PlaylistGraphQL';
